import styled, { css } from 'styled-components';

import LockedIcon from 'components/icons/locked';
import { LoyaltyLoader } from 'pages/loyalty/loyalty-loader';
import { primitive } from 'styles/constants/primitives';

import { CategoryImage as DefaultCategoryImage } from './loyalty-rewards.styled.default';

export * from './loyalty-rewards.styled.default';

export const CategoryImage = styled(DefaultCategoryImage)`
  display: none;
`;
export const CarouselRewardName = styled.div`
  color: ${p => p.theme.token('text-link-default')};
  font-family: ${Styles.fontFamily.base};
  font-weight: 700;
  text-align: center;
  height: 3rem;
  line-height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${Styles.desktop} {
    font-size: 1.2rem;
  }
`;
export const CarouselHeadingLabel = styled.span`
  font-family: ${Styles.fontFamily.base};
  font-weight: 600;
`;

export const PointsNeededText = styled.div`
  font-family: ${Styles.fontFamily.base};
  font-size: 1.3rem;
  margin-inline-start: auto;
  margin-inline-end: 0.5em;

  ${Styles.desktop} {
    margin-inline-end: 0;
  }
`;

export const CarouselItemPoints = styled.div<{ locked?: boolean; condensed?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p =>
    p.locked ? Styles.color.codeBlockBackground : Styles.color.contrastBackground};
  color: ${p => (p.locked ? Styles.color.contrastBackground : primitive.$white)};
  width: fit-content;
  margin-block-start: 0.5em;
  margin-block-end: 0;
  margin-inline: auto;
  padding: 0.2em 0.6em;
  border-radius: 0.25rem;
  line-height: 1.125rem;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 0.25rem;

  ${p =>
    p.condensed &&
    p.locked &&
    css`
      color: ${primitive.plk.$nolaDark};
      background: ${primitive.plk.$nolaLight};
    `}
`;

export const CarouselRewardLock = styled(LockedIcon)`
  width: 1rem;
  height: 1rem;

  & path {
    fill: ${primitive.plk.$nolaDark};
  }
`;

export const LockOverlay = styled.div<{ condensed?: boolean }>`
  width: ${p => (p.condensed ? '100%' : 'calc(100% - 1rem)')};
  height: ${p => (p.condensed ? '6.25rem' : '8rem')};
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  background: ${primitive.$black};
  border-radius: 0.5rem;
  margin: ${p => (p.condensed ? '0' : '0 0.5rem')};
  opacity: 0.5;

  ${Styles.desktop} {
    height: ${(p: any) => (p.condensed ? '7.375rem' : '13.5rem')};
  }
`;

export const StyledLoyaltyLoader = styled(LoyaltyLoader)``;
